import React from 'react'
import { Container } from 'react-bootstrap'
import GoogleMapWithDirections from '../../components/GoogleDirections/GoogleMapWithDirections'
import SEO from '../../components/SEO'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocation } from '@fortawesome/free-solid-svg-icons/faLocation'
import { faDirections } from '@fortawesome/free-solid-svg-icons/faDirections'
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock'

import location from '../../assets/sarahAdomLocation.png'
import './Location.css'

const ADDRESS = '7701 Sudley Road , Manassas, VA 20109'
const ADDRESS_FULL = `Sarah Adom Braiding Salon, ${ADDRESS}`
const GOOGLE_MAPS_DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(ADDRESS_FULL)}`
const GOOGLE_MAPS_SEARCH_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS_FULL)}`
const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyCNHEa4WLAJvgzoZptLJETQePYSmM8FhTY'

const Location = () => {
  return (
    <div className="location-page">
      <SEO title="Visit Us" description="Find Sarah Adom Braiding Salon in Manassas, VA. Get directions and opening hours." />
      <Container>
        <section className="location-hero">
          <span className="location-label">Find us</span>
          <h1 className="location-title">Visit Us</h1>
          <p className="location-desc">We can’t wait to see you at the salon.</p>
        </section>

        <div className="location-image-wrap">
          <img src={location} alt="Sarah Adom Braiding Salon location" />
        </div>

        <div className="location-address-card">
          <div className="location-address-icon">
            <FontAwesomeIcon icon={faLocation} />
          </div>
          <div className="location-address-content">
            <p className="location-address-text">{ADDRESS_FULL}</p>
            <a
              href={GOOGLE_MAPS_DIRECTIONS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="location-directions-btn"
            >
              <FontAwesomeIcon icon={faDirections} className="location-directions-icon" />
              Get directions
            </a>
          </div>
        </div>

        <div className="location-hours-card">
          <div className="location-hours-icon">
            <FontAwesomeIcon icon={faClock} />
          </div>
          <div className="location-hours-content">
            <p className="location-hours-title">Opening hours</p>
            <p className="location-hours-text">Mon–Sat: 7:30am – 7:00pm</p>
            <p className="location-hours-text">Sun: 10:00am – 6:00pm</p>
          </div>
        </div>

        <div className="location-map-wrap">
          {GoogleMapWithDirections && apiKey ? (
            <GoogleMapWithDirections apiKey={apiKey} />
          ) : (
            <a href={GOOGLE_MAPS_SEARCH_URL} target="_blank" rel="noopener noreferrer" className="location-map-fallback">
              View on Google Maps
            </a>
          )}
        </div>
      </Container>
    </div>
  )
}

export default Location